import { Settings, UserPen, GitBranch, ChevronRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useUIStore } from "../../stores/uiStore";

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
}

export default function SettingsModal({ open, onClose }: SettingsModalProps) {
  const openEditProfile = useUIStore((s) => s.openEditProfile);
  const openBranches = useUIStore((s) => s.openBranches);

  const handleEditProfile = () => {
    onClose();
    openEditProfile();
  };

  const handleBranches = () => {
    onClose();
    openBranches();
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader className="pb-4 border-b border-[hsl(var(--border))]">
          <DialogTitle className="font-mono flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Settings
          </DialogTitle>
        </DialogHeader>

        <div className="py-2">
          <button
            onClick={handleEditProfile}
            className="w-full flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-[hsl(var(--muted))] transition-colors text-left"
          >
            <div className="h-10 w-10 rounded-lg bg-[hsl(var(--muted))] flex items-center justify-center">
              <UserPen className="h-5 w-5 text-[hsl(var(--muted-foreground))]" />
            </div>
            <div className="flex-1">
              <div className="font-medium">Edit Profile</div>
              <div className="text-sm text-[hsl(var(--muted-foreground))]">
                Update your name, bio, and social links
              </div>
            </div>
            <ChevronRight className="h-5 w-5 text-[hsl(var(--muted-foreground))]" />
          </button>

          <button
            onClick={handleBranches}
            className="w-full flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-[hsl(var(--muted))] transition-colors text-left"
          >
            <div className="h-10 w-10 rounded-lg bg-[hsl(var(--muted))] flex items-center justify-center">
              <GitBranch className="h-5 w-5 text-[hsl(var(--muted-foreground))]" />
            </div>
            <div className="flex-1">
              <div className="font-medium">Branches</div>
              <div className="text-sm text-[hsl(var(--muted-foreground))]">
                Manage your commit branches
              </div>
            </div>
            <ChevronRight className="h-5 w-5 text-[hsl(var(--muted-foreground))]" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
